<template lang="pug">
.relation-ship-panel
  .relation-ship-content
    slot
  .relation-ship-actions
    .button-collect(v-if="collect" @click="$emit('collect')")
      template(v-if="collectStatus")
        img.icon(src="@/assets/common/icon-collect-active.svg")
        .label 已收藏
      template(v-else)
        img.icon(src="@/assets/common/icon-collect.svg")
        .label 收藏
    .button-share(v-if="share" @click="$emit('share')")
      img.icon(src="@/assets/common/icon-share.svg")
      .label 分享
</template>

<script>
export default {
  name: "RelationShipPanel",
  props: {
    collect: {
      type: Boolean,
      default: true,
    },
    share: {
      type: Boolean,
      default: false,
    },
    collectStatus: [Boolean, Number],
  }
}
</script>

<style lang="scss" scoped>
.relation-ship-panel{
  display: flex;
  align-items: flex-start;
  .relation-ship-content{
    flex: 1;
  }
  .relation-ship-actions{
    padding-right: 24px;
    padding-top: 4px;
    display: flex;
    .button-collect,
    .button-share{
      width: 44px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      @extend .finger;
      .icon{
        @include square(24px);
        margin-bottom: 4px;
      }
      .label{
        font-size: 12px;
        color: #999999;

      }
    }
    .button-collect{
      margin-left: 22px;
    }
    .button-share{
      margin-left: 12px;
    }
  }
}
</style>
